import 'whatwg-fetch';

const API_URL = 'https://api.netlify.com/api/v1/speed_tests';
const POP_COUNT = 6;

function createSpeedtest (url) {
  return fetch(API_URL, {
    method: 'POST',
    body: JSON.stringify({url}),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return response.json();
  }).then((json) => {
    return json;
  }).catch((err) => {
    return err;
  });
}

function getResults(id) {
  return fetch(API_URL + '/' + id).then((response) => {
    return response.json();
  }).then((json) => {
    return json;
  }).catch(function(err) {
    return err;
  });
}

function allPopsResponded(results) {
  const pops = {http: [], https: []};
  for (const key in results) {
    pops[key.split("-")[2]].push(true);
  }
  // We always get https results, even if they're all false
  // So use those to determine if we have a full set
  return pops.https.length >= POP_COUNT;
}

function recursivePoll(id, times, res, rej) {
  getResults(id).then((data) => {
    if(!allPopsResponded(data.results) && times > 1) {
      setTimeout(() => recursivePoll(id, times - 1, res, rej), 1000);
    } else{
      res(data.results);
    }
  }).catch(function() {
    rej();
  });
}

function pollResults (id, times) {
  return new Promise(function(resolve, reject) {
    recursivePoll(id, times, resolve, reject);
  }).then(function (response) {
    return response;
  }).catch(function() {
    return Error;
  });
}

function createReport (id, email) {
  return fetch(`${API_URL}/${id}/report`, {
    method: 'POST',
    body: JSON.stringify({email}),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return response.json();
  }).then((json) => {
    return json;
  }).catch((err) => {
    return err;
  });
}

export default {
  createSpeedtest: createSpeedtest,
  getResults: getResults,
  pollResults: pollResults,
  createReport: createReport
};



// WEBPACK FOOTER //
// ./src/utils/api.js